import { db } from '@/firebase/config'
import { doc, setDoc, serverTimestamp } from 'firebase/firestore'

const updateLocationPhoto = async (locationId, durl) => {
    try {
        await setDoc(
            doc(db, "locations", locationId),
            {
                photoURL: durl + '&dnpa=' + Date.now(),
                edited: serverTimestamp(),
            },
            { merge: true }
        )
    } catch (error) {
        console.error('Error updating location photo metadata', error);
    }

    return
}
export default updateLocationPhoto